// src/utils/periods.js
// Периоды «Сегодня», «Вчера», «Неделя»… строятся от учётного дня ресторана (GET /data/business_day),
// а не от часов устройства: ночью, пока вчерашние смены открыты, «Сегодня» — это ещё вчерашний день.
// Даты — строки 'yyyy-MM-dd' в локальном календаре, без toISOString() (он переводит в UTC и сдвигает день).
import {
  format,
  parseISO,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
  subWeeks,
  subMonths,
  subYears,
} from 'date-fns';

const DAY_FORMAT = 'yyyy-MM-dd';
const WEEK_OPTIONS = { weekStartsOn: 1 };

export const toDayString = (date) => format(date, DAY_FORMAT);

// 'yyyy-MM-dd' → Date в локальную полночь (new Date('yyyy-MM-dd') дал бы полночь UTC)
export const parseDay = (day) => parseISO(day);

// Разовый период «один день» из ссылки (/metrics?day=yyyy-MM-dd — из сводки после закрытия смены)
export const isDayString = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(parseDay(value).getTime());

// Календарная дата по MSK — запасной вариант, если учётный день получить не удалось
export function todayMsk() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow' }).format(new Date());
}

export function getPeriodRange(period, businessDay) {
  const today = parseDay(businessDay);
  const range = (from, to) => ({ from: toDayString(from), to: toDayString(to) });

  switch (period) {
    case 'yesterday': {
      const yesterday = subDays(today, 1);
      return range(yesterday, yesterday);
    }
    case 'week':
      return range(startOfWeek(today, WEEK_OPTIONS), today);
    case 'month':
      return range(startOfMonth(today), today);
    case 'lastWeek':
      return range(startOfWeek(subWeeks(today, 1), WEEK_OPTIONS), subDays(startOfWeek(today, WEEK_OPTIONS), 1));
    case 'lastMonth':
      return range(startOfMonth(subMonths(today, 1)), subDays(startOfMonth(today), 1));
    case 'year':
      return range(startOfYear(today), today);
    case 'prevYear':
      return range(startOfYear(subYears(today, 1)), subDays(startOfYear(today), 1));
    default:
      return range(today, today);
  }
}

// Короткая подпись дат периода рядом с его названием: «21.10» или «16.10 – 21.10»
export function formatPeriodShort(range) {
  if (!range?.from || !range?.to) return '';
  const short = (day) => format(parseDay(day), 'dd.MM');
  return range.from === range.to ? short(range.from) : `${short(range.from)} – ${short(range.to)}`;
}
